import {
  POST_LOGIN_STATIC_FRONT_REDIRECT,
  STATIC_FRONT_REDIRECT_SEARCH_PREFIX,
} from "../firebase/helper";
import { isLocalhost } from "../utils/isLocalhost";

import { API_CONFIG } from "./config";

const STATIC_FRONT_PATH_PREFIX = "/o/";

// nginx が付ける search は ?redirect= のみで、$request_uri はエスケープされない。
// URLSearchParams で読むと値に含まれる2つ目以降のクエリが落ちるため、以降を丸ごと取り出す
const readRedirect = (search: string): string | null => {
  if (!search.startsWith(STATIC_FRONT_REDIRECT_SEARCH_PREFIX)) return null;
  const target = search.slice(STATIC_FRONT_REDIRECT_SEARCH_PREFIX.length);
  return target.startsWith(STATIC_FRONT_PATH_PREFIX) ? target : null;
};

const takeStaticFrontRedirect = (): string | null => {
  const stored = sessionStorage.getItem(POST_LOGIN_STATIC_FRONT_REDIRECT);
  if (stored !== null)
    sessionStorage.removeItem(POST_LOGIN_STATIC_FRONT_REDIRECT);
  const target = readRedirect(stored ?? location.search);
  if (target === null) return null;

  // cookieを発行できているのに nginx が 401 を返し続ける場合、遷移先から弾き返されて同じURLに
  // 戻ってくる。この時 referrer が自分自身になるため、往復し続けないよう遷移をやめる
  if (document.referrer === location.href) return null;
  return target;
};

export const syncStaticFrontSession = async (
  idToken: string
): Promise<void> => {
  // /o/ 配下の配信に利用するため、cookieに認証情報を設定する.
  // localhostの場合、同時にnginxを立ち上げないとエラーになるためreturnする
  if (isLocalhost()) return;

  // API_CLIENTのbaseURLは、 api.{env}sheets.algo-artis.ai/v1 だが、そのまま用いるとapi.(略)のオリジンにcookieが設定されてしまう
  // そのため、fetchで相対パスを用い、nginxに中継させることで {env}sheets.algo-artis.ai のオリジンにcookieを設定する
  const res = await fetch("/static_front/session", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "X-API-KEY": API_CONFIG.API_KEY,
      Authorization: `Bearer ${idToken}`,
    },
  });

  if (!res.ok) {
    throw new Error(
      `static front session cookie の発行に失敗しました: ${res.status}`,
      { cause: res }
    );
  }

  // /o/ 配下にredirectが設定されていたら、そのURLに遷移する
  const redirect = takeStaticFrontRedirect();
  if (redirect === null) return;
  location.replace(redirect);
};

export const deleteStaticFrontSession = async (): Promise<void> => {
  if (isLocalhost()) return;

  // cookieはHttpOnlyのためJSからは削除できない。nginxにMax-Age=0のSet-Cookieを返させる
  // ログアウト直後はURL_LOGOUTへの遷移が並行して走るため、keepaliveで中断されないようにする
  await fetch("/static_front/session_delete", {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
  });
};
